import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { message } from "antd";
import {
  UserDataGetwt,
  UserDataGet,
  User_StateGet,
} from "../Api/CoreApi";
import Footer from "./Footer/Footer";
import About from "./components/About/About";
import HeaderSection from "./components/HeaderSection/HeaderSection";
import HeroSection from "./components/HeroSection/HeroSection";
import SearchSection from "./components/SearchSection/SearchSection";
import ResultsSection from "./components/ResultsSection/ResultsSection";
import SuccessStories from "./components/SuccessStories/SuccessStories";
import "./Home_Page_WLog.css";

const Home_Page_WLog = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = localStorage.getItem("user_id");
  const isLoggedIn = !!id;

  const [activeTab, setActiveTab] = useState("home");
  const [availableStates, setAvailableStates] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState({ total: 0, verified: 0, premium: 0 });
  const [myProfile, setMyProfile] = useState(null);
  const [currentUserGender, setCurrentUserGender] = useState("");

  const [searchValues, setSearchValues] = useState({
    gender: "", minage: "", maxage: "",
    state: "", district: "", religion: "", caste: "",
  });
  const [searchIdValue, setSearchIdValue] = useState("");

  useEffect(() => {
    const path = location.pathname;
    if (path === "/" || path === "/Home_Page_WLog") setActiveTab("home");
    if (path.includes("User_Reg") || path.includes("Registration")) setActiveTab("signup");
  }, [location]);

const get = async () => {
  try {
    setLoading(true);
    await User_StateGet();

  
    const response = await UserDataGetwt();

    let allUsersData = [];
    let backendMyId = null;

    if (Array.isArray(response)) {
      allUsersData = response;
    } else if (response?.profiles) {
      allUsersData = response.profiles;
      backendMyId = response.my_user_id;
    }

    console.log("📦 Total profiles:", allUsersData.length);
    console.log("🔑 Login status:", isLoggedIn);
    console.log("🆔 localStorage user_id:", id);
    console.log("🆔 backend my_user_id:", backendMyId);

    // ✅ Debug - sample profile fields
    if (allUsersData.length > 0) {
      console.log("📋 SAMPLE PROFILE:", {
        bid: allUsersData[0].bid,
        user_id: allUsersData[0].user_id,
        User_id: allUsersData[0].User_id,
        username: allUsersData[0].username,
        firstname: allUsersData[0].firstname,
        gender: allUsersData[0].gender,
        caste: allUsersData[0].caste,
        religion: allUsersData[0].religion,
      });
    }

    let me = null;

    if (isLoggedIn) {
      const myId = id; // localStorage user_id

      // ✅ Method 1: backend my_user_id se (most reliable)
      if (backendMyId) {
        me = allUsersData.find(
          (p) =>
            String(p.bid) === String(backendMyId) ||
            String(p.user_id) === String(backendMyId) ||
            String(p.User_id) === String(backendMyId)
        );
        if (me) console.log("✅ Found via backend my_user_id");
      }

      // ✅ Method 2: localStorage id se
      if (!me && myId) {
        me = allUsersData.find(
          (p) =>
            String(p.bid) === String(myId) ||
            String(p.user_id) === String(myId) ||
            String(p.User_id) === String(myId)
        );
        if (me) console.log("✅ Found via localStorage id");
      }

      // ✅ Method 3: username se
      if (!me) {
        const myUsername = localStorage.getItem("username");
        if (myUsername) {
          me = allUsersData.find(
            (p) =>
              String(p.username || "").toLowerCase() ===
              String(myUsername).toLowerCase()
          );
          if (me) console.log("✅ Found via username");
        }
      }

      if (me) {
        console.log("👤 MY PROFILE:", {
          name: me.firstname || me.username,
          gender: me.gender,
          caste: me.caste,
          religion: me.religion,
        });
      } else {
        console.warn("❌ My profile NOT found");
        // ✅ Debug ke liye pehle 3 profiles ka bid dikhao
        console.log(
          "Sample bids:",
          allUsersData.slice(0, 3).map((p) => ({
            bid: p.bid,
            user_id: p.user_id,
            name: p.firstname,
          }))
        );
      }
    }

    setMyProfile(me || null);
    if (me?.gender) setCurrentUserGender(me.gender);

    // ✅ Mera profile hata do
    let otherProfiles = allUsersData;
    if (me) {
      otherProfiles = allUsersData.filter((p) => {
        if (me.bid && String(p.bid) === String(me.bid)) return false;
        if (me.user_id && String(p.user_id) === String(me.user_id))
          return false;
        if (me.User_id && String(p.User_id) === String(me.User_id))
          return false;
        if (
          me.username &&
          String(p.username).toLowerCase() ===
            String(me.username).toLowerCase()
        )
          return false;
        return true;
      });
      console.log("🚫 After removing my profile:", otherProfiles.length);
    }

    setAllUsers(otherProfiles);

    // ✅ Smart filter apply
    const filtered = applySmartFilter(otherProfiles, me);
    console.log("🎯 Final filtered data:", filtered.length);
    setData(filtered);

    // States
    const uniqueStates = [
      ...new Set(
        otherProfiles
          .filter((u) => u.state && u.state.trim() !== "")
          .map((u) => u.state)
      ),
    ].sort();
    setAvailableStates(uniqueStates);

    setStats({
      total: allUsersData.length,
      verified: allUsersData.filter((u) => u.verified).length,
      premium: allUsersData.filter((u) => u.premium).length,
    });
  } catch (error) {
    console.error("❌ Error:", error);
    message.error("Failed to load profiles");
  } finally {
    setLoading(false);
  }
};
  // ✅ SMART FILTER - Sabse important logic
  const applySmartFilter = (profiles, me) => {
    if (!profiles || profiles.length === 0) return [];

    // ✅ Login nahi hai - sab dikhao as-is
    if (!isLoggedIn || !me) {
      console.log("👥 Not logged in - showing all profiles");
      return profiles;
    }

    let filtered = [...profiles];

    // ✅ STEP 1: OPPOSITE GENDER FILTER (mandatory)
    if (me.gender) {
      const opposite = me.gender === "Male" ? "Female" : "Male";
      filtered = filtered.filter(
        (p) => p.gender?.toLowerCase() === opposite.toLowerCase()
      );
      console.log(`👤 After ${opposite} filter:`, filtered.length);
    }

    // ✅ STEP 2: SCORE-BASED SORT
    // Same caste = 100 pts (TOP)
    // Same religion = 50 pts (MIDDLE)
    // Others = 0 pts (BOTTOM)
    const myCaste = (me.caste || "").toLowerCase().trim();
    const myReligion = (me.religion || "").toLowerCase().trim();

    filtered = filtered.map((p) => {
      let score = 0;
      const pCaste = (p.caste || "").toLowerCase().trim();
      const pReligion = (p.religion || "").toLowerCase().trim();

      if (myCaste && pCaste === myCaste) score += 100;
      if (myReligion && pReligion === myReligion) score += 50;

      return { ...p, _matchScore: score };
    });

    filtered.sort((a, b) => b._matchScore - a._matchScore);

    // Stats
    const sameCasteCount = filtered.filter(p => p._matchScore >= 100).length;
    const sameReligionCount = filtered.filter(p => p._matchScore === 50).length;
    console.log(`🏆 Same Caste: ${sameCasteCount} | Same Religion: ${sameReligionCount}`);

    return filtered;
  };

  useEffect(() => {
    get();
  }, []);

  // ✅ Search filter - apply on user filter changes
  useEffect(() => {
    if (allUsers.length === 0) return;

    let filtered = applySmartFilter(allUsers, myProfile);

    filtered = filtered.filter((user) => {
      if (searchValues.gender &&
        user.gender?.toLowerCase() !== searchValues.gender.toLowerCase()
      ) return false;
      if (searchValues.minage && user.age &&
        parseInt(user.age) < parseInt(searchValues.minage)
      ) return false;
      if (searchValues.maxage && user.age &&
        parseInt(user.age) > parseInt(searchValues.maxage)
      ) return false;
      if (searchValues.state &&
        user.state?.toLowerCase() !== searchValues.state.toLowerCase()
      ) return false;
      if (searchValues.district &&
        !user.district?.toLowerCase().includes(searchValues.district.toLowerCase())
      ) return false;
      if (searchValues.religion &&
        user.religion?.toLowerCase() !== searchValues.religion.toLowerCase()
      ) return false;
      if (searchValues.caste &&
        !user.caste?.toLowerCase().includes(searchValues.caste.toLowerCase())
      ) return false;
      return true;
    });

    setData(filtered);
  }, [searchValues, allUsers, myProfile]);

  // ✅ ID search
  useEffect(() => {
    if (allUsers.length === 0) return;

    if (!searchIdValue || searchIdValue.trim() === "") {
      const isAdvancedEmpty =
        !searchValues.gender && !searchValues.minage &&
        !searchValues.maxage && !searchValues.state &&
        !searchValues.district && !searchValues.religion &&
        !searchValues.caste;

      if (isAdvancedEmpty) {
        setData(applySmartFilter(allUsers, myProfile));
      }
      return;
    }

    let cleanId = searchIdValue.toString().trim().toUpperCase();
    if (cleanId.startsWith("CR")) cleanId = cleanId.substring(2);

    let filtered = applySmartFilter(allUsers, myProfile);

    const result = filtered.filter((user) => {
      const userRef = user.ref?.toString().padStart(6, "0") || "";
      const userProfileId = user.profile_id?.toString().padStart(6, "0") || "";
      const userRefer = user.refer?.toString().padStart(6, "0") || "";
      return (
        userRef.includes(cleanId) ||
        userProfileId.includes(cleanId) ||
        userRefer.includes(cleanId)
      );
    });

    setData(result);
  }, [searchIdValue, allUsers, myProfile]);

  return (
    <div className="home-container">
      <HeaderSection
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        isLoggedIn={isLoggedIn}
      />
      <HeroSection stats={stats} isLoggedIn={isLoggedIn} />
      <SearchSection
        searchValues={searchValues}
        setSearchValues={setSearchValues}
        searchIdValue={searchIdValue}
        setSearchIdValue={setSearchIdValue}
        availableStates={availableStates}
        loading={loading}
        isLoggedIn={isLoggedIn}
        currentUserGender={currentUserGender}
        myProfile={myProfile}
        allUsers={allUsers}
        setData={setData}
      />
      <ResultsSection
        data={data}
        loading={loading}
        isLoggedIn={isLoggedIn}
        currentUserGender={currentUserGender}
        myProfile={myProfile}
        searchValues={searchValues}
        searchIdValue={searchIdValue}
      />
      <div id="about-section">
        <About />
      </div>
      <SuccessStories />
      <Footer />
    </div>
  );
};

export default Home_Page_WLog;